import { render, staticRenderFns } from "./DeclaracaoPlanoContaCadastro.vue?vue&type=template&id=05fc5502&scoped=true&"
import script from "./DeclaracaoPlanoContaCadastro.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoPlanoContaCadastro.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoPlanoContaCadastro.vue?vue&type=style&index=0&id=05fc5502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fc5502",
  null
  
)

export default component.exports